<template>
  <div class="pb-5">
    <div class="form-row">
      <div class="col-12 mb-4"><p class="h5">Hai un codice promozionale?</p></div>
      <div class="form-group col-md-5">
        <input
          v-model="couponCode"
          placeholder="Inserisci qui il tuo codice promozionale"
          name="promo_code"
          type="text"
          class="form-control"
          :class="{
            'is-valid': coupon ? coupon.valid : false
          }"
          id="promoCode">
      </div>
      <div v-if="$apollo.loading" class="form-group" style="display: flex; align-items: center">
        <i class="fas fa-2x fa-spin fa-circle-notch"></i>
      </div>
    </div>
    <div v-if="coupon && coupon.valid">
      Coupon valido. Sarà applicato uno sconto del {{ coupon.percent_off }}% per
      <span v-if="coupon.duration === 'FOREVER'">
        sempre
      </span>
      <span v-if="coupon.duration === 'REPEATING'">
        {{ coupon.duration_in_months }} mesi
      </span>
      <span v-if="coupon.duration === 'ONCE'">
        questa transazione
      </span>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "CouponInput",
  data() {
    return {
      couponCode: "",
      coupon: undefined,
    }
  },
  watch: {
    coupon(newCoupon, oldCoupon) {
      if (newCoupon && newCoupon.valid) {
        this.$emit('coupon-update', newCoupon);
      }
    },
    couponCode(newCouponCode, oldCouponCode) {
      this.$emit('coupon-update', undefined);
      this.coupon = undefined;
    }
  },
  apollo: {
    coupon: {
      query: gql`query ($coupon: String!) {
        validateCoupon(coupon: $coupon) {
          amount_off
          duration
          duration_in_months
          percent_off
          valid
        }
      }`,
      variables() {
        return {
          coupon: this.couponCode,
        }
      },
      skip() {
        return !(this.couponCode.length !== 0);
      },
      update: data => data.validateCoupon,
    }
  }
}
</script>

<style scoped>

</style>
